<template>
  <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="1000" persistent>
    <div class="modern-modal">
      <!-- Header -->
      <div class="modern-modal-header">
        <div class="modern-modal-title">
          <div class="modern-modal-icon" :style="{ background: isEdit ? 'linear-gradient(135deg, #f59e0b, #d97706)' : (selfMode ? 'linear-gradient(135deg, #10b981, #059669)' : 'linear-gradient(135deg, #3b82f6, #6366f1)') }">
            <i class="fa-solid" :class="isEdit ? 'fa-pen-to-square' : (selfMode ? 'fa-user-check' : 'fa-list-check')"></i>
          </div>
          <div>
            <h3>{{ isEdit ? 'Topshiriqni Tahrirlash' : (selfMode ? 'O\'zim uchun topshiriq' : 'Yangi topshiriq') }}</h3>
            <p>{{ isEdit ? 'Mavjud vazifaning tafsilotlarini o\'zgartirish' : (selfMode ? 'Shaxsiy vazifa — ijrochi sifatida o\'zingiz biriktirilasiz' : 'Loyiha va jamoa uchun yangi vazifani rejalashtirish') }}</p>
          </div>
        </div>
        <div class="modern-modal-actions">
          <v-btn v-if="!isEdit && !selfMode" variant="outlined" color="primary" class="modern-btn-outline" @click="$emit('open-file-dialog')" prepend-icon="mdi-file-excel" size="small">
            Fayldan yuklash
          </v-btn>
          <v-btn icon="mdi-close" variant="text" size="small" @click="closeDialog" class="modern-close-btn"></v-btn>
        </div>
      </div>

      <!-- Body -->
      <div class="modern-modal-body">
        <form @submit.prevent="submitTask" autocomplete="off">
          <div class="modern-grid-container">
            <!-- LEFT PANEL -->
            <div class="modern-panel">
              <!-- <h4 class="modern-section-title">Asosiy ma'lumotlar</h4> -->
              
              <div class="modern-form-group">
                <label for="projectName" class="modern-label">Topshiriq nomi <span class="required-asterisk">*</span></label>
                <input type="text" class="modern-input" id="projectName" v-model="form.taskName"
                  placeholder="Masalan: Dasturning yangi versiyasini o'rnatish" autocomplete="off" required />
              </div>

              <div class="modern-form-group">
                <label for="task-description" class="modern-label">Topshiriq matni <span class="required-asterisk">*</span></label>
                <textarea class="modern-textarea" id="task-description" rows="1" v-model="form.taskDescription"
                  placeholder="Topshiriq bo‘yicha batafsil ma’lumot kiriting..." required></textarea>
              </div>

              <!-- FILES SECTION (Collapsible) -->
              <div class="modern-form-group border-top pt-3">
                <div class="d-flex justify-content-between align-items-center mb-2" style="cursor: pointer;" @click="isFilesOpen = !isFilesOpen">
                  <label class="modern-label mb-0" style="cursor: pointer; font-size: 14px; color: #1e293b;"><i class="fa-solid fa-paperclip me-2 text-primary"></i> Qo'shimcha hujjat / fayl</label>
                  <span class="material-symbols-outlined" style="transition: transform 0.2s; color: #64748b;" :style="isFilesOpen ? 'transform: rotate(180deg)' : ''">expand_more</span>
                </div>
                <transition name="collapse">
                  <div v-show="isFilesOpen">
                    <div class="modern-file-upload">
                      <input type="file" id="formFile" multiple @change="handleFileUpload" class="modern-file-input" />
                      <div class="modern-file-dropzone" :class="{ 'has-file': form.files && form.files.length > 0 }">
                        <i class="fa-solid" :class="(form.files && form.files.length > 0) ? 'fa-file-circle-check text-success' : 'fa-cloud-arrow-up'"></i>
                        <span>{{ (form.files && form.files.length > 0) ? form.files.length + ' ta fayl biriktirildi' : 'Fayllarni tanlang yoki shu yerga tashlang' }}</span>
                      </div>
                    </div>

                    <!-- Selected Files Preview List -->
                    <div v-if="form.files && form.files.length > 0" class="modern-file-preview-list mt-3">
                      <div v-for="(file, index) in form.files" :key="index" class="modern-file-preview-item">
                        <div class="d-flex align-items-center">
                          <div class="file-icon-wrapper">
                            <i class="fa-solid fa-file-lines text-primary"></i>
                          </div>
                          <div class="file-details ms-2">
                            <div class="file-name text-truncate" :title="file.name" style="max-width: 250px;">{{ file.name }}</div>
                            <div class="file-size text-muted" style="font-size: 11px;">{{ (file.size / 1024).toFixed(1) }} KB</div>
                          </div>
                        </div>
                        <button type="button" class="btn-close" style="font-size: 10px;" @click.stop="removeFile(index)"></button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>

              <!-- SUBTASKS SECTION (Only during creation) -->
              <div class="modern-form-group mt-4 pt-3 border-top" v-if="!isEdit">
                <div class="d-flex justify-content-between align-items-center mb-2" style="cursor: pointer;" @click="isSubtasksOpen = !isSubtasksOpen">
                  <label class="modern-label mb-0" style="font-size: 14px; color: #1e293b; cursor: pointer;">
                    <i class="fa-solid fa-list-check me-2 text-primary"></i> Subtask
                  </label>
                  <div class="d-flex align-items-center">
                    <v-btn size="small" variant="text" color="primary" @click.stop="addSubtask(); isSubtasksOpen = true;" prepend-icon="mdi-plus" class="modern-btn-outline border-0 me-2" style="font-weight: 600;">Yangi qator</v-btn>
                    <span class="material-symbols-outlined" style="transition: transform 0.2s; color: #64748b;" :style="isSubtasksOpen ? 'transform: rotate(180deg)' : ''">expand_more</span>
                  </div>
                </div>
                
                <transition name="collapse">
                  <div v-show="isSubtasksOpen">
                    <div v-for="(sub, sIdx) in form.subtasks" :key="sIdx" class="p-2 mb-2" style="background: #ffffff; border: 1px solid #eef2f6; border-radius: 8px; box-shadow: 0 2px 6px rgba(0,0,0,0.02); transition: all 0.2s;">
                  <div class="d-flex justify-content-between mb-2 align-items-center">
                    <span style="font-size: 10px; font-weight: 700; color: #64748b; text-transform: uppercase;"><i class="fa-solid fa-list-check me-1"></i> Vazifa #{{ sIdx + 1 }}</span>
                    <button type="button" class="modern-remove-btn" style="width: 20px; height: 20px; background: #fff1f2; color: #ef4444;" @click="removeSubtask(sIdx)">
                      <i class="fa fa-times" style="font-size: 10px;"></i>
                    </button>
                  </div>
                  
                  <!-- Yakkama-yakka kichik qatorlar -->
                  <div class="row g-1 mb-1">
                    <div class="col-8">
                      <input type="text" class="form-control" v-model="sub.name" placeholder="Vazifa nomi..." required style="border-radius: 4px; padding: 2px 6px; font-size: 11px; height: 26px; background: #f8fafc; border: 1px solid #e2e8f0;" />
                    </div>
                    <div class="col-4">
                      <v-date-input v-model="sub.deadline" clearable variant="outlined" :min="today" label="Muddat" density="compact" bg-color="#f8fafc" hide-details class="super-compact-input"></v-date-input>
                    </div>
                  </div>
                  
                  <textarea class="form-control mb-1" rows="1" v-model="sub.description" placeholder="Vazifa tavsifi..." style="border-radius: 4px; padding: 4px 6px; font-size: 11px; min-height: 26px; background: #f8fafc; border: 1px solid #e2e8f0;"></textarea>
                  
                  <!-- Multiple Assignees for subtask -->
                  <div class="p-1" style="background: #f8fafc; border-radius: 4px; border: 1px dashed #cbd5e1;">
                    <div class="row g-1 align-items-center mb-1">
                      <div class="col-5">
                        <v-autocomplete
                          v-model="sub.newAssignee.user_id"
                          :items="availableEmployeesForSubtask(sIdx)"
                          color="primary"
                          item-title="name"
                          item-value="id"
                          label="Xodim"
                          variant="outlined"
                          bg-color="#ffffff"
                          density="compact"
                          hide-details
                          class="super-compact-input"
                        >
                          <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :prepend-avatar="getEmployeeAvatar(item.raw.id)" :title="item.raw.name" density="compact" style="font-size: 11px; min-height: 24px; padding: 0 8px;"></v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>
                      <div class="col-4">
                        <v-select v-model="sub.newAssignee.process" :items="availableProcessesForSubtask(sIdx)" label="Rol" variant="outlined" density="compact" bg-color="#ffffff" hide-details class="super-compact-input"></v-select>
                      </div>
                      <div class="col-3">
                        <button type="button" class="btn btn-primary w-100" @click="addSubtaskMember(sIdx)" :disabled="!sub.newAssignee.user_id || !sub.newAssignee.process" style="height: 26px; font-size: 10px; font-weight: 600; padding: 0; border-radius: 4px;">
                          Qo'shish
                        </button>
                      </div>
                    </div>
                    
                    <div v-if="sub.assignees && sub.assignees.length > 0" class="d-flex flex-wrap gap-1 mt-2 border-top pt-2">
                      <span v-for="(mem, mIdx) in sub.assignees" :key="mIdx" class="badge bg-white text-dark border d-flex align-items-center px-1 py-1 shadow-sm" style="border-radius: 4px; font-weight: 500; font-size: 10px;">
                        <img :src="getEmployeeAvatar(mem.user_id)" width="14" height="14" class="rounded-circle me-1" style="object-fit: cover;" />
                        {{ getEmployeeName(mem.user_id) }} <span class="text-muted ms-1" style="font-size: 9px;">({{ mem.process }})</span>
                        <i class="fa fa-times text-danger ms-1" style="cursor: pointer;" @click="removeSubtaskMember(sIdx, mIdx)"></i>
                      </span>
                    </div>

                    <!-- Ijro ijrochisi majburiy — ogohlantirish -->
                    <div v-if="!subtaskHasExecutor(sub)" class="subtask-warn mt-2">
                      <i class="fa-solid fa-triangle-exclamation"></i>
                      Ijro uchun kamida bitta xodim biriktiring
                    </div>
                  </div>
                </div>
                
                <div v-if="!form.subtasks.length" class="text-center p-3" style="border: 2px dashed #cbd5e1; border-radius: 12px; color: #94a3b8; font-size: 13px; cursor: pointer; transition: all 0.2s;" @click="addSubtask">
                  <i class="fa-solid fa-plus-circle mb-1" style="font-size: 18px;"></i><br>
                Qo'shish
                </div>
                  </div>
                </transition>
              </div>
            </div>

            <!-- RIGHT PANEL -->
            <div class="modern-panel modern-panel-right">
              <!-- <h4 class="modern-section-title">Muddat va Ijrochilar</h4> -->

              <!-- 1-qator: Muddat -->
              <div class="d-flex align-items-end gap-3 mb-4">
                <div class="flex-grow-1">
                  <label class="modern-label mb-1 d-block">Bajarish muddati</label>
                  <v-date-input v-model="form.taskDeadlineFormatted" clearable variant="outlined" :min="today"
                    :input-attrs="{ autocomplete: 'new-password', name: 'taskDeadline' }" 
                    density="compact" bg-color="#f8fafc" required
                    prepend-icon="" prepend-inner-icon="mdi-calendar" hide-details class="modern-compact-input w-100"
                  ></v-date-input>
                </div>
                <div style="width: 130px; flex-shrink: 0;"></div>
              </div>

              <!-- 2-qator: Xodim va Switch -->
              <div v-if="!selfMode" class="d-flex align-items-end gap-3 mb-4">
                <div class="flex-grow-1">
                  <label class="modern-label mb-1 d-block">Xodim biriktirish</label>
                  <v-autocomplete
                    v-model="newMember.user_id"
                    :items="availableEmployees"
                    :disabled="isSubmitting"
                    color="primary"
                    item-title="name"
                    item-value="id"
                    placeholder="Xodimni tanlang..."
                    prepend-inner-icon="mdi-account-search"
                    variant="outlined"
                    bg-color="#f8fafc"
                    density="compact"
                    hide-details
                    menu-icon="mdi-chevron-down"
                    class="modern-compact-input w-100"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :prepend-avatar="getEmployeeAvatar(item.raw.id)"
                        :subtitle="item.raw.group" :title="item.raw.name">
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div style="width: 130px; flex-shrink: 0;" class="d-flex align-items-center justify-content-center pb-1">
                  <v-switch
                    v-model="internalIsWideSearch"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                    label="Kengroq"
                    class="modern-beautiful-switch"
                    @change="onWideSearchToggle"
                  ></v-switch>
                </div>
              </div>

              <!-- 3-qator: Jarayon va Tugma -->
              <div v-if="!selfMode" class="d-flex align-items-end gap-3 mb-4">
                <div class="flex-grow-1">
                  <label class="modern-label mb-1 d-block">Jarayon (rol)</label>
                  <v-select v-model="newMember.process" :items="availableProcesses"
                    :disabled="!newMember.user_id" variant="outlined" density="compact" bg-color="#f8fafc" hide-details class="modern-compact-input w-100"></v-select>
                </div>
                <div style="width: 130px; flex-shrink: 0;">
                  <v-btn color="primary" class="modern-add-btn w-100" elevation="0" height="40" @click="addMember"
                    :disabled="!newMember.user_id || !newMember.process">Qo‘shish</v-btn>
                </div>
              </div>

              <!-- O'zi uchun rejim: faqat "Malumot" uchun xodim qo'shish -->
              <div v-if="selfMode" class="d-flex align-items-end gap-3 mb-4">
                <div class="flex-grow-1">
                  <label class="modern-label mb-1 d-block">
                    Ma'lumot uchun xodim
                    <span class="self-role-hint">ixtiyoriy</span>
                  </label>
                  <v-autocomplete
                    v-model="newMember.user_id"
                    :items="availableEmployees"
                    :disabled="isSubmitting"
                    color="primary"
                    item-title="name"
                    item-value="id"
                    placeholder="Xodimni tanlang..."
                    prepend-inner-icon="mdi-account-search"
                    variant="outlined"
                    bg-color="#f8fafc"
                    density="compact"
                    hide-details
                    menu-icon="mdi-chevron-down"
                    class="modern-compact-input w-100"
                  >
                    <template v-slot:item="{ props, item }">
                      <v-list-item v-bind="props" :prepend-avatar="getEmployeeAvatar(item.raw.id)"
                        :subtitle="item.raw.group" :title="item.raw.name">
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </div>
                <div style="width: 130px; flex-shrink: 0;">
                  <v-btn color="primary" class="modern-add-btn w-100" elevation="0" height="40"
                    @click="addInfoMember" :disabled="!newMember.user_id">Qo‘shish</v-btn>
                </div>
              </div>

              <div class="modern-members-section">
                <div class="modern-label d-flex justify-content-between mb-2">
                  <span>{{ selfMode ? 'Ishtirokchilar' : 'Bajaruvchilar' }}</span>
                  <span class="modern-badge" v-if="selfMode && infoMembers.length">+{{ infoMembers.length }} ma'lumot uchun</span>
                  <span class="modern-badge" v-else-if="!selfMode && form.selectedMembers.length">{{ form.selectedMembers.length }} kishi</span>
                </div>
                <div v-if="orgResolving" class="manager-loading-hint mb-2">
                  <i class="fa-solid fa-circle-notch fa-spin"></i> Ijrochi rahbarlari qo'shilmoqda…
                </div>

                <!-- O'zi uchun rejim: ijrochi (o'chirilmaydi) + Malumot a'zolari -->
                <template v-if="selfMode">
                  <div class="self-member-card">
                    <img :src="getEmployeeAvatar(currentUserId)" alt="" class="modern-member-avatar" />
                    <div class="modern-member-info">
                      <h5>{{ getEmployeeName(currentUserId) }}</h5>
                      <span class="modern-member-role">Ijro uchun · o'zingiz</span>
                    </div>
                    <span class="self-member-tag"><i class="fa-solid fa-user-check"></i> Siz</span>
                  </div>

                  <div v-if="infoMembers.length" class="modern-members-list mt-2">
                    <div v-for="member in infoMembers" :key="member.user_id" class="modern-member-card">
                      <img :src="getEmployeeAvatar(member.user_id)" alt="" class="modern-member-avatar" />
                      <div class="modern-member-info">
                        <h5>{{ getEmployeeName(member.user_id) }}</h5>
                        <span class="modern-member-role">
                          Malumot uchun
                          <span v-if="isAutoManager(member.user_id)" class="manager-tag"><i class="fa-solid fa-user-tie"></i> rahbar</span>
                        </span>
                      </div>
                      <button type="button" @click="removeMemberByUserId(member.user_id)" class="modern-remove-btn">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </template>

                <template v-else>
                  <div v-if="form.selectedMembers.length" class="modern-members-list">
                    <div v-for="(member, index) in form.selectedMembers" :key="index" class="modern-member-card">
                      <img :src="getEmployeeAvatar(member.user_id)" alt="" class="modern-member-avatar" />
                      <div class="modern-member-info">
                        <h5>{{ getEmployeeName(member.user_id) }}</h5>
                        <span class="modern-member-role">
                          {{ member.process }} uchun
                          <span v-if="isAutoManager(member.user_id)" class="manager-tag"><i class="fa-solid fa-user-tie"></i> rahbar</span>
                        </span>
                      </div>
                      <button type="button" @click="removeMember(index)" class="modern-remove-btn">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else class="modern-empty-state">
                    <div class="modern-empty-icon"><i class="fa-regular fa-user"></i></div>
                    <p>Hozircha ijrochi biriktirilmadi</p>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modern-modal-footer">
            <v-btn variant="text" color="grey-darken-1" size="large" @click="closeDialog" class="modern-cancel-btn">Bekor qilish</v-btn>
            <v-btn type="submit" :color="isEdit ? 'warning' : (selfMode ? 'success' : 'primary')" size="large" class="modern-submit-btn" :loading="isSubmitting" elevation="2" :append-icon="isEdit ? 'mdi-check' : 'mdi-arrow-right'">
              {{ isEdit ? 'Saqlash' : 'Yaratish' }}
            </v-btn>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import Swal from "sweetalert2";
import { VDateInput } from "vuetify/labs/VDateInput";

export default {
  name: "TaskFormModal",
  components: {
    VDateInput,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    taskData: {
      type: Object,
      default: () => null,
    },
    templateData: {
      type: Object,
      default: () => null,
    },
    myEmployees: {
      type: Array,
      default: () => [],
    },
    employees: {
      type: Array,
      default: () => [],
    },
    processes: {
      type: Array,
      default: () => ["Rozilik", "Ijro", "Malumot", "Test"],
    },
    isWideSearchModel: {
      type: Boolean,
      default: false,
    },
    columnId: {
      type: [String, Number],
      default: 1, // Default "Yangi topshiriqlar"
    },
    // Faqat o'zi uchun topshiriq rejimi — ijrochi avtomatik joriy foydalanuvchi
    selfMode: {
      type: Boolean,
      default: false,
    }
  },
  emits: ["update:modelValue", "update:isWideSearchModel", "success", "open-file-dialog"],
  data() {
    return {
      today: new Date().toISOString().slice(0, 10),
      isSubmitting: false,
      internalIsWideSearch: this.isWideSearchModel,
      fileUploadName: "",
      isFilesOpen: false,
      isSubtasksOpen: false,
      
      form: {
        taskName: "",
        taskDescription: "",
        taskDeadlineFormatted: null,
        files: [],
        selectedMembers: [],
        subtasks: [],
      },
      
      newMember: {
        user_id: null,
        process: 'Ijro',
      },

      // Ijrochining rahbarlarini avtomatik "Malumot" uchun qo'shish (org daraxti bo'yicha)
      orgMembersCache: {},   // teamId -> flatData (parentId ierarxiyasi)
      relevantTeamIds: null, // yuklangan team(lar) id lari
      primaryTeamId: null,   // workspacega tegishli asosiy team (ustun tuzilma)
      orgDirectory: {},      // user_id -> { name, avatar } (rahbarlar uchun)
      autoManagerIds: [],    // avtomatik qo'shilgan rahbarlar user_id lari
      suppressedManagerIds: [], // foydalanuvchi qo'lda o'chirgan rahbarlar (qayta qo'shilmaydi)
      orgResolving: false,
    };
  },
  computed: {
    currentUserId() {
      return this.$store?.state?.user?.id;
    },
    availableEmployees() {
      const selectedIds = this.form.selectedMembers.map((member) => member.user_id);
      // O'zi uchun rejimda /task-users dan kelgan to'liq ro'yxatdan tanlanadi
      const source = this.selfMode
        ? this.employees
        : (this.internalIsWideSearch ? this.employees : this.myEmployees);
      return source.filter(
        (employee) => !selectedIds.includes(employee.id) && employee.id != this.currentUserId
      );
    },
    // O'zi uchun rejimda qo'shilgan "Malumot" a'zolari
    infoMembers() {
      return this.form.selectedMembers.filter(
        (m) => m.user_id !== this.currentUserId && m.process === "Malumot"
      );
    },
    availableProcesses() {
      const singleAssignmentProcesses = ["Rozilik", "Ijro"];
      const usedProcesses = this.form.selectedMembers
        .filter((member) => singleAssignmentProcesses.includes(member.process))
        .map((member) => member.process);
      return this.processes.filter(
        (process) =>
          !usedProcesses.includes(process) ||
          !singleAssignmentProcesses.includes(process)
      );
    },
    formattedDeadlineResult() {
      if (!this.form.taskDeadlineFormatted) return null;
      return new Date(this.form.taskDeadlineFormatted).toLocaleDateString("en-CA"); // yyyy-mm-dd
    }
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        if (this.isEdit && this.taskData) {
          this.initEditData();
        } else if (this.templateData) {
          this.initTemplateData();
        } else {
          this.resetForm();
        }
      } else {
        this.$emit('update:templateData', null);
      }
    },
    isWideSearchModel(newVal) {
      this.internalIsWideSearch = newVal;
    }
  },
  methods: {
    closeDialog() {
      this.$emit('update:modelValue', false);
    },
    onWideSearchToggle() {
      this.$emit('update:isWideSearchModel', this.internalIsWideSearch);
    },
    resetManagerState() {
      this.relevantTeamIds = null;
      this.primaryTeamId = null;
      this.orgMembersCache = {};
      this.orgDirectory = {};
      this.autoManagerIds = [];
      this.suppressedManagerIds = [];
      this.orgResolving = false;
    },
    initEditData() {
      this.resetManagerState();
      this.form.taskName = this.taskData.text || this.taskData.task_name || "";
      this.form.taskDescription = this.taskData.description || this.taskData.task_description || "";
      this.form.taskDeadlineFormatted = this.taskData.deadline ? new Date(this.taskData.deadline) : null;
      // Copy array so we don't mutate prop directly until submit
      this.form.selectedMembers = Array.isArray(this.taskData.members) 
        ? JSON.parse(JSON.stringify(this.taskData.members)) 
        : [];
      this.form.files = [];
      this.fileUploadName = "";
      this.newMember = { user_id: null, process: 'Ijro' };
    },
    initTemplateData() {
      this.resetManagerState();
      this.form.taskName = this.templateData.taskName || "";
      this.form.taskDescription = this.templateData.taskDescription || "";
      this.form.taskDeadlineFormatted = null;
      this.form.files = [];
      this.fileUploadName = "";
      this.form.selectedMembers = Array.isArray(this.templateData.selectedMembers) 
        ? JSON.parse(JSON.stringify(this.templateData.selectedMembers)) 
        : [];
      this.form.subtasks = Array.isArray(this.templateData.subtasks)
        ? JSON.parse(JSON.stringify(this.templateData.subtasks)).map(sub => {
            if (!sub.assignees) sub.assignees = [];
            if (!sub.newAssignee) sub.newAssignee = { user_id: null, process: null };
            if (sub.assignee && sub.assignee.user_id) {
               sub.assignees.push(sub.assignee);
               delete sub.assignee;
            }
            return sub;
          })
        : [];
      this.newMember = { user_id: null, process: 'Ijro' };
    },
    resetForm() {
      this.resetManagerState();
      this.form.taskName = "";
      this.form.taskDescription = "";
      this.form.taskDeadlineFormatted = null;
      this.form.files = [];
      this.fileUploadName = "";
      this.form.selectedMembers = [];
      this.form.subtasks = [];
      this.newMember = { user_id: null, process: 'Ijro' };

      // O'zi uchun rejim: ijrochi sifatida joriy foydalanuvchini avtomatik qo'shamiz
      if (this.selfMode && this.currentUserId) {
        this.form.selectedMembers = [
          { user_id: this.currentUserId, process: 'Ijro' },
        ];
        this.newMember = { user_id: null, process: 'Malumot' };
        // O'z taski bo'lsa ham: o'zining (ijrochining) rahbarlari Malumot uchun qo'shiladi
        this.applyExecutorManagers();
      }
    },
    addSubtask() {
      this.form.subtasks.push({
        name: "",
        description: "",
        deadline: null,
        assignees: [],
        newAssignee: { user_id: null, process: "Ijro" }
      });
    },
    removeSubtask(index) {
      this.form.subtasks.splice(index, 1);
    },
    addSubtaskMember(sIdx) {
      const sub = this.form.subtasks[sIdx];
      if (sub.newAssignee.user_id && sub.newAssignee.process) {
        if (!sub.assignees) sub.assignees = [];
        sub.assignees.push({ ...sub.newAssignee });
        // Ijro band bo'lsa keyingi standart rol Malumot bo'ladi
        const nextProcess = this.availableProcessesForSubtask(sIdx).includes("Ijro") ? "Ijro" : (this.availableProcessesForSubtask(sIdx)[0] || null);
        sub.newAssignee = { user_id: null, process: nextProcess };
      }
    },
    removeSubtaskMember(sIdx, mIdx) {
      this.form.subtasks[sIdx].assignees.splice(mIdx, 1);
    },
    subtaskHasExecutor(sub) {
      return (sub.assignees || []).some((a) => a.process === "Ijro");
    },
    availableEmployeesForSubtask(sIdx) {
      const sub = this.form.subtasks[sIdx];
      const selectedIds = sub.assignees ? sub.assignees.map(m => m.user_id) : [];
      const source = this.internalIsWideSearch ? this.employees : this.myEmployees;
      return source.filter(emp => !selectedIds.includes(emp.id) && emp.id != this.currentUserId);
    },
    availableProcessesForSubtask(sIdx) {
      const sub = this.form.subtasks[sIdx];
      const singleAssignmentProcesses = ["Rozilik", "Ijro"];
      const usedProcesses = sub.assignees
        ? sub.assignees.filter(m => singleAssignmentProcesses.includes(m.process)).map(m => m.process)
        : [];
      return this.processes.filter(p => !usedProcesses.includes(p) || !singleAssignmentProcesses.includes(p));
    },
    handleFileUpload(event) {
      const selectedFiles = event.target.files;
      if (selectedFiles && selectedFiles.length > 0) {
        this.form.files = [...this.form.files, ...Array.from(selectedFiles)];
        event.target.value = null; // reset input
      }
    },
    removeFile(index) {
      this.form.files.splice(index, 1);
    },
    addMember() {
      if (this.newMember.user_id && this.newMember.process) {
        const proc = this.newMember.process;
        // Qo'lda qo'shilgan rahbarni "suppressed" ro'yxatidan chiqaramiz
        this.suppressedManagerIds = this.suppressedManagerIds.filter(
          (id) => String(id) !== String(this.newMember.user_id)
        );
        this.form.selectedMembers.push({ ...this.newMember });
        const nextProcess = this.availableProcesses.includes('Ijro') ? 'Ijro' : (this.availableProcesses[0] || null);
        this.newMember = { user_id: null, process: nextProcess };
        // Ijrochi qo'shilsa — uning rahbarlarini avtomatik Malumot uchun qo'shamiz
        if (proc === 'Ijro') this.applyExecutorManagers();
      }
    },
    removeMember(index) {
      const removed = this.form.selectedMembers[index];
      this.form.selectedMembers.splice(index, 1);
      if (!removed) return;
      // Avtomatik qo'shilgan rahbar qo'lda o'chirilsa — qayta qo'shilmasin
      if (this.isAutoManager(removed.user_id)) {
        this.autoManagerIds = this.autoManagerIds.filter(
          (id) => String(id) !== String(removed.user_id)
        );
        if (!this.suppressedManagerIds.map(String).includes(String(removed.user_id))) {
          this.suppressedManagerIds.push(removed.user_id);
        }
        return;
      }
      // Ijrochi olib tashlansa — "Ijro" roli yana bo'shaydi. Keyingi qo'shish uchun
      // standart rolni "Ijro" ga qaytaramiz (aks holda ikkinchi ijrochi noto'g'ri
      // rol bilan qo'shilib, rahbarlar ishga tushmaydi).
      if (removed.process === "Ijro") {
        if (this.availableProcesses.includes("Ijro")) this.newMember.process = "Ijro";
        this.applyExecutorManagers();
      }
    },
    // O'zi uchun rejim: xodimni faqat "Malumot" roli bilan qo'shamiz
    addInfoMember() {
      if (!this.newMember.user_id) return;
      const exists = this.form.selectedMembers.some(
        (m) => m.user_id === this.newMember.user_id
      );
      if (!exists) {
        this.form.selectedMembers.push({
          user_id: this.newMember.user_id,
          process: "Malumot",
        });
      }
      this.newMember = { user_id: null, process: "Malumot" };
    },
    removeMemberByUserId(userId) {
      const idx = this.form.selectedMembers.findIndex((m) => m.user_id === userId);
      if (idx !== -1) this.removeMember(idx);
    },

    isAutoManager(userId) {
      return this.autoManagerIds.map(String).includes(String(userId));
    },
    toNumberId(id) {
      const n = Number(id);
      return Number.isNaN(n) ? id : n;
    },

    // Joriy loyihaga bog'langan team(lar)ni aniqlab, ularning org a'zolarini yuklaymiz
    async ensureOrgData() {
      if (this.relevantTeamIds !== null) return; // shu ochilishda bir marta hal qilinadi
      this.relevantTeamIds = []; // qayta kirishni oldini olish (race)
      this.orgResolving = true;
      try {
        const projectId = localStorage.getItem("current_workspace_id");

        // Faqat joriy workspace(loyiha)ga tegishli team_id — bitta org chart.
        let primaryTeamId = null;
        try {
          const wsRes = await api.get("/workspaces", { meta: { al: false } });
          const list = wsRes.data || [];
          const ws = list.find((w) => String(w.id) === String(projectId));
          if (ws) primaryTeamId = ws.team_id ?? ws.teamId ?? ws.team?.id ?? null;
        } catch (e) {
          /* jim o'tamiz */
        }
        this.primaryTeamId = primaryTeamId;
        this.relevantTeamIds = primaryTeamId != null ? [primaryTeamId] : [];

        if (primaryTeamId != null && !this.orgMembersCache[primaryTeamId]) {
          try {
            const data = (
              await api.get(`/organization-members/${primaryTeamId}`, { meta: { al: false } })
            ).data;
            const flat = Array.isArray(data) ? data : [];
            this.orgMembersCache[primaryTeamId] = flat;
            flat.forEach((n) => {
              this.orgDirectory[String(n.id)] = { name: n.name, avatar: n.avatar };
            });
          } catch (e) {
            this.orgMembersCache[primaryTeamId] = [];
          }
        }
      } finally {
        this.orgResolving = false;
      }
    },

    // Workspace team_id org chartini bitta xaritaga aylantiramiz (id -> tugun).
    buildCombinedMap() {
      const map = {};
      (this.orgMembersCache[this.primaryTeamId] || []).forEach((n) => {
        map[String(n.id)] = n;
      });
      return map;
    },

    // Berilgan xodimning rahbarlar zanjiri (yuqoriga parentId bo'ylab), id lar ro'yxati.
    // Rahbarning tugun obyekti yuklanmagan bo'lsa ham uning id si (parentId) olinadi —
    // shunda zanjir uzilmasdan eng yuqorigacha yig'iladi.
    ancestorsChain(map, userId) {
      const res = [];
      const seen = new Set();
      let cur = map[String(userId)];
      while (cur) {
        const pid = cur.parentId;
        if (pid === null || pid === undefined || String(pid) === "null" || String(pid) === "") break;
        const pidStr = String(pid);
        if (seen.has(pidStr)) break;
        seen.add(pidStr);
        res.push(pidStr); // rahbar id — tugun bo'lmasa ham qo'shamiz
        const parent = map[pidStr];
        if (!parent) break; // tugun yo'q: id ni oldik, lekin undan yuqoriga chiqolmaymiz
        cur = parent;
      }
      return res;
    },

    // Ijrochi(lar)ning rahbarlarini "Malumot" uchun sinxronlaymiz (topshiriq beruvchidan tashqari)
    async applyExecutorManagers() {
      if (this.isEdit) return; // faqat yaratishda
      try {
        await this.ensureOrgData();
      } catch (e) {
        return;
      }
      // Barcha team daraxtlarini bitta xaritaga birlashtiramiz (asosiy team ustun)
      const map = this.buildCombinedMap();
      if (!Object.keys(map).length) return;

      const authorId = this.currentUserId;
      const authorStr = String(authorId);

      // Joriy ijrochilar (o'zi uchun rejimda — joriy foydalanuvchi ham ijrochi)
      const executorIds = new Set(
        this.form.selectedMembers
          .filter((m) => m.process === "Ijro")
          .map((m) => String(m.user_id))
      );
      if (this.selfMode && authorId) executorIds.add(String(authorStr));

      // Har bir ijrochining butun rahbarlar zanjirini (eng yuqorigacha) yig'amiz
      const desired = new Set();
      executorIds.forEach((eid) => {
        this.ancestorsChain(map, eid).forEach((id) => desired.add(id));
      });
      // Topshiriq beruvchi (muallif), ijrochilarning o'zi va qo'lda o'chirilganlar chiqarib tashlanadi
      desired.delete(authorStr);
      executorIds.forEach((id) => desired.delete(id));
      this.suppressedManagerIds.forEach((id) => desired.delete(String(id)));

      // Diagnostika: zanjir qayerda uzilganini aniq ko'rish uchun
      console.debug("[managers] teamIds:", [...(this.relevantTeamIds || [])],
        "primaryTeam:", this.primaryTeamId,
        "mapNodes:", Object.keys(map).length,
        "executors:", [...executorIds],
        "author:", authorStr,
        "desiredManagers:", [...desired]);
      executorIds.forEach((eid) => {
        const chainIds = this.ancestorsChain(map, eid);
        const chain = chainIds.map((id) => {
          const n = map[id];
          return n ? `${n.name || id}(id=${id})` : `id=${id}(TUGUN YUKLANMAGAN)`;
        });
        const found = map[String(eid)] ? "" : " — ijrochi XARITADA TOPILMADI";
        console.debug(`[managers] ijrochi ${eid}${found} zanjiri: ` + (chain.join(" → ") || "(bo'sh)"));
      });

      // Endi kerak bo'lmagan avtomatik rahbarlarni olib tashlaymiz
      this.autoManagerIds = this.autoManagerIds.filter((id) => {
        if (!desired.has(String(id))) {
          const idx = this.form.selectedMembers.findIndex(
            (m) => String(m.user_id) === String(id) && m.process === "Malumot"
          );
          if (idx !== -1) this.form.selectedMembers.splice(idx, 1);
          return false;
        }
        return true;
      });

      // Yangi kerakli rahbarlarni Malumot uchun qo'shamiz
      desired.forEach((id) => {
        const exists = this.form.selectedMembers.some(
          (m) => String(m.user_id) === String(id)
        );
        if (!exists) {
          const numId = this.toNumberId(id);
          this.form.selectedMembers.push({ user_id: numId, process: "Malumot" });
          if (!this.autoManagerIds.map(String).includes(String(id))) {
            this.autoManagerIds.push(numId);
          }
        }
      });
    },

    getEmployeeName(id) {
      const employee = this.employees.find((emp) => emp.id === id);
      if (employee) return employee.name;
      // Joriy foydalanuvchi xodimlar ro'yxatida bo'lmasligi mumkin (o'zi uchun rejim)
      const me = this.$store?.state?.user;
      if (me && me.id === id) return `${me.firstname || ""} ${me.lastname || ""}`.trim() || "Men";
      // Rahbar task-users ro'yxatida bo'lmasligi mumkin — org daraxtidan olamiz
      const org = this.orgDirectory[String(id)];
      if (org && org.name) return org.name;
      return "Unknown";
    },
    getEmployeeAvatar(id) {
      const employee = this.employees.find((emp) => emp.id == id);
      const me = this.$store?.state?.user;
      const org = this.orgDirectory[String(id)];
      const avatar =
        employee?.avatar ||
        (me && me.id == id ? me.avatar : null) ||
        org?.avatar ||
        "user.png";
      return `https://api.task-board.uz/storage/user/avatar/${avatar}`;
    },
    async submitTask() {
      if (!this.form.taskName.trim()) {
        Swal.fire({
          icon: "warning",
          title: "Diqqat",
          text: "Iltimos, topshiriq nomini kiriting!",
          confirmButtonText: "Ok",
          customClass: { container: 'swal-z-top' }
        });
        return;
      }

      const hasExecutor = this.form.selectedMembers.some(
        (member) => member.process === "Ijro"
      );
      
      if (!hasExecutor) {
        Swal.fire({
          icon: "warning",
          title: "Diqqat!",
          text: "Ijro uchun xodim biriktiring",
          confirmButtonText: "Ok",
          customClass: { container: 'swal-z-top' }
        });
        return;
      }

      // Har bir subtaskda kamida bitta "Ijro" ijrochisi bo'lishi shart
      const subtasks = this.form.subtasks || [];
      for (let i = 0; i < subtasks.length; i++) {
        const st = subtasks[i];
        const subHasExecutor = (st.assignees || []).some(
          (a) => a.process === "Ijro"
        );
        if (!subHasExecutor) {
          const label = (st.name && st.name.trim()) || `${i + 1}-subtask`;
          Swal.fire({
            icon: "warning",
            title: "Diqqat!",
            text: `Subtask uchun Ijro ijrochisini biriktiring`,
            confirmButtonText: "Ok",
            customClass: { container: 'swal-z-top' }
          });
          return;
        }
      }

      // Yuborishdan oldin ijrochilarning rahbarlari qo'shilganiga ishonch hosil qilamiz
      if (!this.isEdit) {
        try {
          await this.applyExecutorManagers();
        } catch (e) {
          /* jim o'tamiz */
        }
      }

      this.isSubmitting = true;

      try {
        const formData = new FormData();
        formData.append("task_name", this.form.taskName);
        formData.append("task_description", this.form.taskDescription || "");
        formData.append("members", JSON.stringify(this.form.selectedMembers));
        
        if (this.formattedDeadlineResult) {
          formData.append("task_deadline", this.formattedDeadlineResult);
          formData.append("deadline", this.formattedDeadlineResult); // For updateTask compatibility
        }

        if (this.form.files && this.form.files.length > 0) {
          this.form.files.forEach((f) => {
            formData.append("files[]", f);
          });
          // Backward compatibility for current backend
          formData.append("file", this.form.files[0]);
        }

        if (this.isEdit) {
          formData.append("text", this.form.taskName);
          formData.append("description", this.form.taskDescription || "");
          
          await api.post(`/update-task/${this.taskData.id}`, formData);

          Swal.fire({
            icon: "success",
            title: "Muvaffaqiyat",
            text: "Topshiriq muvaffaqiyatli yangilandi!",
            confirmButtonText: "Ok",
            customClass: { container: 'swal-z-top' }
          });

        } else {
          // Creating New Task
          let workspace_id = localStorage.getItem("current_workspace_id");
          if (workspace_id == 'undefined' || workspace_id == null) {
            Swal.fire({
              icon: "warning",
              title: "Diqqat!",
              text: "Loyiha tanlanmagan",
              confirmButtonText: "Ok",
              customClass: { container: 'swal-z-top' }
            });
            return; 
          }
          formData.append("column_id", this.columnId);
          formData.append("project_id", workspace_id);
          
          const response = await api.post("/create-task", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          // Intercept new Task ID for subtasks
          const newTaskId = response.data?.id || response.data?.data?.id || response.data?.task?.id;
          
          if (newTaskId && this.form.subtasks.length > 0) {
            for (const sub of this.form.subtasks) {
              if (sub.name) {
                let subMembers = sub.assignees ? [...sub.assignees] : [];
                // Add any lingering un-added assignee as a fallback
                if (sub.newAssignee && sub.newAssignee.user_id && sub.newAssignee.process) {
                   subMembers.push(sub.newAssignee);
                }
                try {
                  const dates = sub.deadline ? [new Date(sub.deadline).toLocaleDateString("en-CA")] : [];
                  await api.post(`/create-subtask/${newTaskId}`, {
                    name: sub.name,
                    description: sub.description || '',
                    dates: dates,
                    members: subMembers
                  });
                } catch(subErr) {
                  console.error("Subtask error:", subErr);
                }
              }
            }
          }

          Swal.fire({
            icon: "success",
            title: "Yangi vazifa yaratildi",
            confirmButtonText: "Ok",
            customClass: { container: 'swal-z-top' }
          });
        }
        
        this.resetForm();
        this.closeDialog();
        this.$emit("success");

      } catch (error) {
        console.error("Task Request Error:", error.response?.data || error.message);
        const errorMsg = error.response?.data?.errors?.task_deadline?.[0] || 
                         error.response?.data?.message || 
                         "Xato yuz berdi!";
        Swal.fire({
          icon: "error",
          title: "Xato",
          text: errorMsg,
          customClass: { container: 'swal-z-top' }
        });
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style scoped>
/* Collapse Animation */
.collapse-enter-active,
.collapse-leave-active {
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out, transform 0.3s ease-out, margin 0.3s ease-out;
  overflow: hidden;
  max-height: 1000px;
  opacity: 1;
  transform: translateY(0);
}
.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-5px);
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* MODERN MODAL STYLES */
.modern-modal {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.12);
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.modern-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  background: linear-gradient(to right, #f8fafc, #ffffff);
  border-bottom: 1px solid #e2e8f0;
}

.modern-modal-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-modal-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 8px 16px rgba(59, 130, 246, 0.25);
}

.modern-modal-title h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.modern-modal-title p {
  margin: 4px 0 0;
  font-size: 13px;
  color: #64748b;
}

.modern-modal-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.modern-btn-outline {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
  border-color: #e2e8f0;
}

.modern-close-btn {
  background: #f1f5f9;
  color: #64748b;
  border-radius: 50%;
}

.modern-modal-body {
  padding: 0;
  background: #f8fafc;
}

.modern-grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.modern-panel {
  padding: 20px 32px;
  background: #ffffff;
  overflow-y: auto;
  max-height: calc(100vh - 225px);
}

.modern-panel::-webkit-scrollbar {
  width: 4px;
}
.modern-panel::-webkit-scrollbar-track {
  background: transparent;
}
.modern-panel::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.modern-panel-right {
  background: #f8fafc;
  border-left: 1px solid #e2e8f0;
}

.modern-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.modern-form-group {
  margin-bottom: 16px;
}

.modern-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 4px;
}

.required-asterisk {
  color: #ef4444;
}

.modern-input, .modern-textarea {
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #f8fafc;
  font-size: 13.5px;
  color: #1e293b;
  transition: all 0.2s ease;
  min-height: 40px;
}

.modern-textarea {
  /* min-height: 80px; */
  resize: vertical;
}

.modern-input:focus, .modern-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  background: #ffffff;
}

.modern-file-upload {
  position: relative;
  width: 100%;
}

.modern-file-input {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  width: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}

.modern-file-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  transition: all 0.2s ease;
}

.modern-file-upload:hover .modern-file-dropzone {
  border-color: #3b82f6;
  background: #f1f5f9;
  color: #3b82f6;
}

.modern-file-dropzone.has-file {
  border-color: #10b981;
  background: #ecfdf5;
  color: #059669;
}

.modern-file-dropzone i {
  font-size: 28px;
}

.modern-file-preview-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.modern-file-preview-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.file-icon-wrapper {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-details .file-name {
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
}

.modern-file-dropzone span {
  font-size: 13px;
  font-weight: 500;
}

.modern-switch :deep(.v-switch__thumb) {
  background: white;
}
.modern-switch :deep(.v-switch__track) {
  opacity: 0.2;
}

.modern-process-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.modern-add-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 8px;
}

.modern-members-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px dashed #cbd5e1;
}

.modern-badge {
  background: #e0e7ff;
  color: #4f46e5;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
}

.modern-members-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 180px;
  overflow-y: auto;
  padding-right: 4px;
}

.modern-members-list::-webkit-scrollbar {
  width: 4px;
}
.modern-members-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.modern-member-card {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  transition: all 0.2s ease;
}

.modern-member-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

/* O'zi uchun rejim — ijrochi kartasi */
.self-member-card {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: linear-gradient(90deg, #ecfdf5, #ffffff 65%);
  border: 1px solid #a7f3d0;
  border-radius: 10px;
}
.subtask-warn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 600;
  color: #b45309;
  background: rgba(245, 158, 11, 0.1);
  border: 1px solid rgba(245, 158, 11, 0.25);
  border-radius: 6px;
  padding: 4px 8px;
}
.subtask-warn i {
  font-size: 11px;
}
.self-role-hint {
  font-size: 10px;
  font-weight: 600;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 6px;
  text-transform: none;
}
.self-member-tag {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  color: #059669;
  background: rgba(16, 185, 129, 0.12);
  padding: 4px 10px;
  border-radius: 20px;
  white-space: nowrap;
}

.modern-member-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
}

.modern-member-info {
  flex: 1;
}

.modern-member-info h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.modern-member-role {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

/* Avtomatik qo'shilgan rahbar belgisi */
.manager-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  font-size: 10px;
  font-weight: 700;
  color: #7c3aed;
  background: rgba(124, 58, 237, 0.1);
  border: 1px solid rgba(124, 58, 237, 0.22);
  padding: 1px 7px;
  border-radius: 20px;
}
.manager-tag i {
  font-size: 9px;
}
.manager-loading-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #7c3aed;
  background: rgba(124, 58, 237, 0.07);
  border-radius: 6px;
  padding: 5px 10px;
}
.manager-loading-hint i {
  font-size: 10px;
}

.modern-remove-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #94a3b8;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.modern-remove-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

.modern-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 180px;
  color: #94a3b8;
  gap: 12px;
}

.modern-empty-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.modern-empty-state p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
}

.modern-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.modern-submit-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 10px;
}

.modern-cancel-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 10px;
}

/* Super compact inputs */
:deep(.super-compact-input .v-field__input) {
  min-height: 26px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  font-size: 14px !important;
}
:deep(.super-compact-input .v-field) {
  border-radius: 4px;
}
:deep(.super-compact-input .v-label) {
  font-size: 14px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
}
:deep(.super-compact-input .v-label--active) {
  transform: translateY(-130%) scale(0.85) !important;
}
:deep(.super-compact-input .v-field__append-inner) {
  padding-top: 0 !important;
  align-items: center !important;
}
:deep(.super-compact-input .v-field__clearable) {
  padding-top: 0 !important;
  align-items: center !important;
}

/* Make it responsive */
@media (max-width: 900px) {
  .modern-grid-container {
    grid-template-columns: 1fr;
  }
  .modern-panel-right {
    border-left: none;
    border-top: 1px solid #e2e8f0;
  }
}

:deep(.v-autocomplete .v-field__outline),
:deep(.v-date-input .v-field__outline),
:deep(.v-select .v-field__outline) {
  --v-field-border-opacity: 1;
}
:deep(.v-autocomplete .v-field),
:deep(.v-date-input .v-field),
:deep(.v-select .v-field) {
  border-radius: 10px !important;
}
:deep(.modern-panel-right .v-input .v-field) {
  border-radius: 10px !important;
}
:deep(.modern-panel-right .v-input .v-field__outline__start) {
  border-radius: 10px 0 0 10px !important;
  min-width: 10px !important;
}
:deep(.modern-panel-right .v-input .v-field__outline__end) {
  border-radius: 0 10px 10px 0 !important;
}

/* Beautiful Switch Styling */
.modern-beautiful-switch {
  margin-top: 0 !important;
}
:deep(.modern-beautiful-switch .v-selection-control__wrapper) {
  transform: scale(0.75); /* Fqat switch o'zini kichraytiramiz */
  transform-origin: right center;
}
:deep(.modern-beautiful-switch .v-label) {
  font-size: 13.5px !important;
  font-weight: 500;
  color: #64748b;
  opacity: 1;
}
:deep(.modern-beautiful-switch .v-switch__track) {
  background-color: #cbd5e1;
  opacity: 1;
}

/* Compact input styling */
.modern-compact-input {
  max-width: 100%;
}
:deep(.modern-compact-input .v-field__input) {
  min-height: 40px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  font-size: 13.5px !important;
}
:deep(.modern-compact-input .v-label) {
  font-size: 13.5px !important;
}
:deep(.modern-compact-input .v-field__outline) {
  --v-field-border-opacity: 0.15;
}
:deep(.modern-compact-input:hover .v-field__outline) {
  --v-field-border-opacity: 0.3;
}
</style>

<style>
/* SweetAlert modallarini v-dialog dan yuqorida chiqarish uchun */
.swal-z-top {
  z-index: 99999 !important;
}
</style>
